// customTheme.js
import { createTheme } from '@mui/material/styles';
import { shades } from '../../../../theme.js';

const customTheme = createTheme({
  palette: {
    primary: {
      main: shades.secondary[700]
    },
    background: {
      default: shades.white[100]
    },
    text: {
      primary: shades.neutral[900],
      secondary: shades.neutral[700]
    }
  },
  typography: {
    // This will apply to Typography variant="h6" by default.
    h6: {
      fontWeight: 'bold',
      color: shades.neutral[900]
    },
    subtitle1: {
      fontWeight: 'bold',
      color: shades.secondary[700]
    },
    body1: {
      color: shades.secondary[300]
    },
    body2: {
      color: shades.neutral[600]
    }
  },
  components: {
    // Paper – used in your "Start a post" and other sections
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: shades.white[100],
          boxShadow: 'none',
          border: '1px solid #ddd',
          borderRadius: 10
        }
      }
    },
    // Card – for your posts
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: shades.white[100],
          boxShadow: 'none',
          border: '1px solid #ddd',
          cursor: 'pointer'
        }
      }
    },
    // CardContent – inside each Card
    MuiCardContent: {
      styleOverrides: {
        root: {
          backgroundColor: shades.white[100],
          borderRadius: 5
        }
      }
    },
    // Avatar – default background and text color
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: shades.neutral[200],
          color: shades.white[100]
        }
      }
    },
    // Button – customizing contained buttons (Publish, Comment, etc.)
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        },
        contained: {
          backgroundColor: 'black',
          '&:hover': {
            backgroundColor: shades.secondary[400],
            color: 'white'
          },
          '&.Mui-disabled': {
            backgroundColor: shades.secondary[200],
            color: 'white'
          }
        }
      }
    },
    // Divider – used between sections and comments
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: shades.neutral[200],
          margin: '8px 0'
        }
      }
    },
    // Dialog and its sub-components (Title, Content, Actions)
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: shades.white[100],
          height: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: shades.white[100],
          padding: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px'
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: shades.white[100],
          padding: '24px'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          backgroundColor: shades.white[100],
          padding: '16px'
        }
      }
    },
    // TextField – general styling for inputs
    MuiTextField: {
      defaultProps: {
        margin: 'dense'
      },
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            fontSize: '1rem',
            color: shades.neutral[900]
          },
          '& .MuiInputLabel-root': {
            color: 'darkgray'
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black'
          },
          // For outlined variant (used for comments)
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: shades.neutral[300]
            },
            '&:hover fieldset': {
              borderColor: shades.neutral[300]
            },
            '&.Mui-focused fieldset': {
              borderColor: shades.neutral[500]
            }
          }
        }
      }
    },
    // Menu – for the post options menu
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#2e2e2e'
        }
      }
    },
    // IconButton – default color for icons
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: shades.neutral[700]
        }
      }
    }
  }
});

export default customTheme;
